import { useApi } from './api';

export const useDashboardService = () => {
  const { apiFetch } = useApi();

  const getTotalReferrals = async () => {
    const res = await apiFetch('/referrals/count'); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener el total de casos');
    return res.json();
  };

  const getTotalClaims = async () => {
    const res = await apiFetch('/referrals/claims/count'); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener el total de citas');
    return res.json();
  };

  // ✅ CORREGIDO: Usar el endpoint correcto para pendientes
  const getPendingSync = async () => {
    const res = await apiFetch('/referrals/pending-sync/count'); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener pendientes de sinc');
    return res.json();
  };

  // ✅ CORREGIDO: Usar el endpoint correcto para errores
  const getSyncErrors = async () => {
    const res = await apiFetch('/referrals/sync-error/count'); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener errores de sinc');
    return res.json();
  };

  return {
    getTotalReferrals,
    getTotalClaims,
    getPendingSync,
    getSyncErrors,
  };
};